export const getNameInitials = (firstName = null, lastName = null) => {
  const firstNameLetter = firstName ? firstName[0] : 'A';
  const lastNameLetter = lastName ? lastName[0] : 'Z';

  return `${firstNameLetter}${lastNameLetter}`.toUpperCase();
};
